import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ExportFileList, DeleteExportFileData } from '@/api/sys.user';
import util from '@/libs/util';
import { mapMutations, mapGetters } from 'vuex';
export default {
  props: {
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapGetters(['$UnreadExportMessionNum'])),
  data: function data() {
    return {
      userName: util.getUserInfo().USER_NAME,
      fileList: [],
      loading: false,
      pageInfo: {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      },
      key: null,
      isShowDelete: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('d2admin/user', ['SET_unreadExportMessionNum'])), {}, {
    // 全部清除
    handleAllDelete: function handleAllDelete(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.fileList.length === 0)) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.warning('数据为空，删除失败');

                return _context2.abrupt("return");

              case 3:
                _this.$confirm('是否删除全部导出记录？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var params, res, fileList, params2, res2;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          params = {
                            'Data.User_Name': _this.userName,
                            Page: 1,
                            Limit: 9999
                          };
                          _context.next = 4;
                          return ExportFileList(params);

                        case 4:
                          res = _context.sent;

                          if (!(res.code === 0)) {
                            _context.next = 12;
                            break;
                          }

                          fileList = res.data.Items.map(function (v) {
                            return v.FileUrl;
                          });
                          params2 = {
                            UserName: _this.userName,
                            FileUrlList: fileList
                          };
                          _context.next = 10;
                          return DeleteExportFileData(params2);

                        case 10:
                          res2 = _context.sent;

                          if (res2.code === 0) {
                            _this.$message.success('记录全部删除成功');

                            _this._ExportFileList();
                          }

                        case 12:
                          _context.next = 17;
                          break;

                        case 14:
                          _context.prev = 14;
                          _context.t0 = _context["catch"](0);

                          _this.$message.warning('系统内部错误');

                        case 17:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 14]]);
                }))).catch(function () {});

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 单条删除
    handleSingleDelete: function handleSingleDelete(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  UserName: _this2.userName,
                  FileUrlList: [item.FileUrl]
                };
                _context3.next = 3;
                return DeleteExportFileData(params);

              case 3:
                res = _context3.sent;
                console.log(res);

                if (res.code === 0) {
                  _this2.$message.success('记录删除成功');

                  _this2._ExportFileList();
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 鼠标离开
    handleFileNameLeave: function handleFileNameLeave(item) {
      item.isShowDelete = false;
    },
    // 鼠标移进
    handleFileNameMouseenter: function handleFileNameMouseenter(item) {
      item.isShowDelete = true;
    },
    // 查看全部
    handleGocheck: function handleGocheck() {
      this.$router.push({
        path: '/System/ExportRecord'
      });
    },
    // 点击清除
    handleClear: function handleClear() {
      this.key = null;

      this._ExportFileList();
    },
    // 点击搜索
    handleSearch: function handleSearch() {
      this._ExportFileList();
    },
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.PageIndex = index;

      this._ExportFileList();
    },
    // 点击刷新
    handleRefresh: function handleRefresh() {
      this._ExportFileList();
    },
    // 点击下载
    handleFileName: function handleFileName(item) {
      console.log(item);

      if (item.Status === 1) {
        if (item.FileName.includes('供应商') || item.FileName.includes('采购员')) {
          window.open(this.$store.getters.getVUE_APP_FILE_PATH + item.FileUrl);
        } else {
          window.open(this.$store.getters.getVUE_APP_DOWN + item.FileUrl);
        } // window.open(this.$store.getters.getVUE_APP_DOWN + item.FileUrl)

      } else if (item.Status === 2) {
        this.$message.warning('数据为空');
      } else {
        this.$message.warning('数据处理中');
      }
    },
    // 获取导出列表
    visibleChange: function visibleChange(display) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log(display);

                if (display === true) {
                  _this3._ExportFileList();
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    switchStatus: function switchStatus(Items) {
      switch (Items.Status) {
        case 0:
          Items.statusName = '处理中';
          Items.statusStyle = 'color:#e6a23c';
          return;

        case 1:
          Items.statusName = '已完成';
          Items.statusStyle = 'color:#00bb7c';
          return;

        case 2:
          Items.statusName = '数据空';
          Items.statusStyle = 'color:#f78989';
      }
    },
    _ExportFileList: function _ExportFileList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, res, unreads;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.loading = true;
                params = {
                  'Data.User_Name': _this4.userName,
                  Page: _this4.pageInfo.PageIndex,
                  Key: _this4.key
                };
                _context5.next = 4;
                return ExportFileList(params);

              case 4:
                res = _context5.sent;
                _this4.loading = false;
                console.log(res);

                if (res.code === 0) {
                  _this4.fileList = res.data.Items.map(function (v) {
                    v.statusName = '获取中...';
                    v.statusStyle = null;

                    _this4.switchStatus(v);

                    v.isShowDelete = false;
                    return v;
                  });
                  unreads = res.data.Items.filter(function (v) {
                    return v.Status === 0;
                  }).length;

                  if (unreads === 0) {
                    _this4.SET_unreadExportMessionNum(null);
                  } else {
                    _this4.SET_unreadExportMessionNum(unreads);
                  }

                  _this4.pageInfo.TotalCount = res.data.TotalCount; // console.log('unreads',unreads);
                } else {
                  _this4.$message.warning('获取下载列表失败');
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  })
};